export default "__VITE_ASSET__BfmHvyCd__"